import TextUtility from '../../../common/utility/TextUtility';
import CustomButton from '../../../common/components/CustomButton';
import CurrencyUtility from '../../../common/utility/CurrencyUtility';

type KaraokeModificationFormView3ModificationViewFieldName =
  'modification_item1'|'modification_item2'|'modification_item3'|
  'modification_details1'|'modification_details2'|'modification_details3';

export default function KaraokeModificationFormView3ModificationView({
  getValue,
  amount,
  onBack,
  onNext,
} : {
  getValue: (name: KaraokeModificationFormView3ModificationViewFieldName) => string,
  amount: number,
  onBack: () => void,
  onNext: () => void,
}) {
  return (
    <>
      <form>
        <div className="form__body">
          <dl>
            <dt>修正理由</dt>
            <dd>お客様都合（提出時に間違った、後から変更することになった場合など）</dd>
          </dl>
          <dl>
            <dt>修正箇所</dt>
            <dd>{getValue('modification_item1')}</dd>
          </dl>
          <dl>
            <dt>修正内容</dt>
            <dd>{TextUtility.nl2br(getValue('modification_details1'))}</dd>
          </dl>
          {getValue('modification_item2') !== '' && getValue('modification_details2') !== '' && (
            <>
              <dl>
                <dt>修正箇所</dt>
                <dd>{getValue('modification_item2')}</dd>
              </dl>
              <dl>
                <dt>修正内容</dt>
                <dd>{TextUtility.nl2br(getValue('modification_details2'))}</dd>
              </dl>
            </>
          )}
          {getValue('modification_item3') !== '' && getValue('modification_details3') !== '' && (
            <>
              <dl>
                <dt>修正箇所</dt>
                <dd>{getValue('modification_item3')}</dd>
              </dl>
              <dl>
                <dt>修正内容</dt>
                <dd>{TextUtility.nl2br(getValue('modification_details3'))}</dd>
              </dl>
            </>
          )}
          <dl>
            <dt>修正手数料</dt>
            <dd>
              {amount > 0 ? `${CurrencyUtility.format(amount)}円` : 'なし'}
            </dd>
          </dl>
          <p className="top_line" />
          <ul>
            <li className="bt">
              <CustomButton type="cancel-split" onClick={() => onBack()}>戻る</CustomButton>
              <CustomButton type="default-split" onClick={() => onNext()}>修正を依頼</CustomButton>
            </li>
          </ul>
        </div>
      </form>
    </>
  );
}
